"use strict";

import $ from 'jquery';
import {isSmallDevice} from './isSmallDevice.js';

const slotBasePath = '/16791533/MAQUIA_3rd/';
const unitNamePrefix = 'maquia_';

const UnitNameDevicePrefix = {
  'largeDevice' : 'PC_',
  'smallDevice' : 'SP_'
};

let firstFlag=true;
let slot = ['largeDevice', 'smallDevice', 'amp'];

slot['largeDevice'] = {
  maquia_PC_pushdown_DFP_3rd       : [[1, 1], [3, 1], [728, 90], [954, 90], [970, 250], [970, 90], 'fluid'],
  maquia_PC_rectangle_1_DFP_3rd    : [[1, 1], [2, 1], [300, 600], [300, 250], 'fluid'],
  maquia_PC_rectangle_7_DFP_3rd    : [[1, 1], [8, 1], [300, 250], 'fluid', [320,200]],
  maquia_PC_inlinebanner_1_DFP_3rd : [[1, 1], [6, 1], 'fluid'],
  maquia_PC_inlinebanner_2_DFP_3rd : [[1, 1], [9, 1], 'fluid'],
};

slot['smallDevice'] = {
  maquia_SP_headerbanner_DFP_3rd   : [[1, 1], [2, 1], [320, 100], [320, 50], 'fluid'],
  maquia_SP_inarticle_1_DFP_3rd    : [[1, 1], [8, 1], 'fluid', [320,180], [300, 250], [336, 280]],
  maquia_SP_inarticle_2_DFP_3rd    : [[1, 1], [9, 1], 'fluid', [320,180], [300, 250], [336, 280]],
  maquia_SP_inarticle_3_DFP_3rd    : [[1, 1], [10, 1], 'fluid', [320,180], [300, 250], [336, 280]],
  maquia_SP_inarticle_4_DFP_3rd    : [[1, 1], [11, 1], 'fluid', [320,180], [300, 250], [336, 280]],
  maquia_SP_inarticle_5_DFP_3rd    : [[1, 1], [12, 1], 'fluid', [320,180], [300, 250], [336, 280]],
  maquia_SP_inarticle_6_DFP_3rd    : [[1, 1], [13, 1], 'fluid', [320,180], [300, 250], [336, 280]],
  maquia_SP_inarticle_7_DFP_3rd    : [[1, 1], [14, 1], 'fluid', [320,180], [300, 250], [336, 280]],
  maquia_SP_inarticle_8_DFP_3rd    : [[1, 1], [15, 1], 'fluid', [320,180], [300, 250], [336, 280]],

  maquia_SP_inlinebanner_1_DFP_3rd : [[1, 1], [3, 1], [300, 250], [336, 280], 'fluid'],
  maquia_SP_inlinebanner_2_DFP_3rd : [[1, 1], [4, 1], [300, 250], [336, 280], 'fluid', [320, 200]],
  maquia_SP_editorial_DFP_3rd      : [[1, 1], [7, 1], [320, 100], 'fluid'],
  maquia_SP_footer_DFP_3rd         : [[1, 1], [6, 1], [320, 50], [320, 100], 'fluid'],
};

function findAdSlot(device) {
  const slots = {
    'initialLoad': [],
    'lazyLoad': [],
  };

  $('[data-ad-unit-name^=' + unitNamePrefix + UnitNameDevicePrefix[device] + ']').not('.is-defined').each(function () {
    const unitName = $(this).attr('data-ad-unit-name');
    const lazyLoad = $(this).attr('data-ad-lazyload');
    if(slot[device][unitName]) {
      const slotPath = slotBasePath + unitName;
      const size = slot[device][unitName];
      const id = $(this).attr('id');

      googletag.cmd.push(function () {
        if (lazyLoad !== 'true') {
          slots['initialLoad'][id] = {path:slotPath,size:size,id:id};
        } else {
          slots['lazyLoad'][id] = {path:slotPath,size:size,id:id};
        }
      });
      $(this).addClass('is-defined');
    }
  });

  return slots;
}

function watchLazyLoadAd(device, slots) {
  if ("IntersectionObserver" in window) {
    const options = {
      rootMargin: "100% 0%"
    };
    const adUnits = document.querySelectorAll('[data-ad-unit-name^=' + unitNamePrefix + UnitNameDevicePrefix[device] + '][data-ad-lazyload=true]');
    const lazyComponentObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          if (entry.boundingClientRect.top > 0) {
            let id = entry.target.id;
            let slotInfo =slots[id];
            if (slotInfo !=undefined){
              googletag.cmd.push(function() {
                refresh([slotInfo]);
                observer.unobserve(entry.target)
              });
            }
          }
        }
      });
    }, options);

    adUnits.forEach(function(components) {
      lazyComponentObserver.observe(components);
    });
  }
}

function refresh(slots) {
  googletag.cmd.push(function () {
    const slotList = [];
    for(const key in slots) {
      const slot = slots[key];
      slotList.push(googletag.defineSlot(slot['path'], slot['size'], slot['id'])
        .addService(googletag.pubads()));
      googletag.display(slot['id']);
    }
    window.atsHB4Lazyload(slotList);
  });
}

export function addNewAd(){
  if (typeof googletag === "undefined" ) {
    return
  }
  let device = isSmallDevice() ? 'smallDevice' : 'largeDevice';
  let slots = findAdSlot(device);
  refresh(slots['initialLoad']);
  watchLazyLoadAd(device, slots['lazyLoad']);
}
export function initialize() {
  if (typeof googletag === "undefined" ) {
    return
  }
  let device = isSmallDevice() ? 'smallDevice' : 'largeDevice';

  googletag.cmd.push(function () {
    googletag.pubads().disableInitialLoad();
    googletag.pubads().enableSingleRequest();
    googletag.enableServices();

    let slots = findAdSlot(device);
    refresh(slots['initialLoad']);

    if ((slots['lazyLoad']) && firstFlag){
      watchLazyLoadAd(device, slots['lazyLoad']);
      firstFlag=false;
    }
  });
}
